export const AUTH_INVALID_EMAIL = {
  title: "Invalid Email",
  description: "Please enter a valid email address.",
};

export const AUTH_WEAK_PASSWORD = {
  title: "Weak Password",
  description: "Your password is too weak. Please choose a stronger password with at least 6 characters.",
};

export const AUTH_PASSWORD_REQUIRED = {
  title: "Password Required",
  description: "Please enter your password to continue.",
};

export const AUTH_CURRENT_PASSWORD_REQUIRED = {
  title: "Current Password Required",
  description: "Please enter your current password to continue.",
};

